var map = {
	"./all.png": 477,
	"./burger.png": 478,
	"./cart.png": 479,
	"./coffee.png": 480,
	"./dark/all.png": 239,
	"./dark/burger.png": 240,
	"./dark/cart.png": 241,
	"./dark/coffee.png": 242,
	"./dark/icecream.png": 243,
	"./dark/pizza.png": 244,
	"./dark/snacks.png": 245,
	"./dark/softdrinks.png": 246,
	"./email.png": 161,
	"./facebook.png": 158,
	"./french-fries.png": 481,
	"./icecream.png": 482,
	"./instagram.png": 159,
	"./phone.png": 160,
	"./pizza.png": 483,
	"./snacks.png": 484,
	"./softdrinks.png": 485,
	"./twitter.png": 157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;